export default __webpack_public_path__ + "static/media/select_arrow.935cca46.svg";